import { Suspense } from 'react'
import { Switch } from 'react-router-dom'

import RequireSignIn from '@main/components/RequireSignIn'
import { Loader } from '@h2/components/loading/loader'
import { RouteWithSubRoutes } from '@h2/common/components/routeWithSubRoutes'
import { routes as cmsRoutes } from '@h2/features/cms/routes'

const renderRoute = ({ path, authenticated, ...rest }) => {
  if (authenticated) {
    return (
      <RouteWithSubRoutes
        key={path}
        path={path}
        {...rest}
        render={props => {
          return <RequireSignIn name={rest.name}>{rest.render(props)}</RequireSignIn>
        }}
      />
    )
  }

  return <RouteWithSubRoutes key={path} path={path} {...rest} />
}
const NoHeaderRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>{cmsRoutes.map(renderRoute)}</Switch>
    </Suspense>
  )
}

export { NoHeaderRouter }
